export default __webpack_public_path__ + "static/media/thaiFlag.1c6fe93f.webp";